import { getPolicy } from 'reduxStore/actions/policy';
import { getPostDetail } from 'reduxStore/actions/posts';
import { getTermsUseInfo } from 'reduxStore/actions/termsOfUse';
import { getProfileDetails } from 'reduxStore/actions/user';

const { createSlice } = require('@reduxjs/toolkit');

const initialState = {
  userLoading: false,
  policyDetails: [],
  error: null,
};
const policySlice = createSlice({
  name: 'policy',
  initialState,
 reducers:{},
  extraReducers: (builder) => {
    builder
      .addCase(getPolicy.fulfilled, (state, action) => {
        state.userLoading = false;
        state.policyDetails = action.payload;
      })
      .addCase(getPolicy.pending, (state) => {
        state.userLoading = true;
        state.error = null;
      })
      .addCase(getPolicy.rejected, (state, action) => {
        state.userLoading = false;
        state.error = action.payload;
      });
  },
});
export default policySlice.reducer;
